/**
 * Centralized cart page selectors
 * All selectors are functions for consistency (even when no arguments needed)
 * 
 * Usage:
 *   const row = document.querySelector(CartSelectors.cart.productItemById(itemId));
 *   const items = document.querySelectorAll(CartSelectors.cart.productItems());
 */
const CartSelectors = {
  cart: {
    productItems: () => '.product-item[data-id]',
    allProductItems: () => '.product-item',

    /**
     * Get product row selector by cart line item id
     * @param {string|number} id - Cart item id
     * @returns {string} `.product-item[data-id="${id}"]`
     */
    productItemById: (id) => `.product-item[data-id="${id}"]`,

    lineItemExtraDetails: () => '.line-item-extra-details',

    lineItemExtraDetailsNonDigital: () => '.line-item-extra-details:not(.digital_download)',

    productRows: () => '.shopping-cart-content .product-item',

    nonWarrantyProductItems: () => '.product-item:not(.warranty-product)',

    /**
     * Get extra details row selector by cart item id
     * @param {string|number} id - Cart item id
     * @returns {string} `.line-item-extra-details[data-id="${id}"]`
     */
    lineItemExtraDetailsById: (id) => `.line-item-extra-details[data-id="${id}"]`,

    /**
     * Prefer line key for duplicate-variant-safe lookups.
     * @param {string} key - Shopify cart line item key
     * @returns {string} `.line-item-extra-details[data-key="${key}"]`
     */
    lineItemExtraDetailsByKey: (key) => {
      const safeKey = (typeof CSS !== 'undefined' && typeof CSS.escape === 'function')
        ? CSS.escape(String(key))
        : String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      return `.line-item-extra-details[data-key="${safeKey}"]`;
    },

    checkoutButton: () => '.checkout_button_submit',

    delivery: {
      container: () => '.delivery_date',
      wrapper: () => '.checkout_delevory_date',
      checkedRadioInContainer: () => '.delivery_date [name="delivery_date"]:checked',
      checkedRadio: () => '[name="delivery_date"]:checked',
    },

    totals: {
      cart: () => '.info-checkout.info-total .item.total',
      cartMoney: () => '.info-checkout.info-total .item.total .money',
      shipping: () => '.info-checkout.info-shipp-total .shipping_total',
      recycle: () => '.info-checkout.info-recycle-total .recycle_total',
      subTotal: () => '.info-checkout.info-subtotal .item.subtotal, .info-subtotal .subtotal',
    },

    shipping: {
      items: () => '.shipping-radio .shipping-item',
      upsItems: () => '.shipping-radio .shipping-item.ups-ship',
      form: () => '.form-shipping',
      radio: () => '.shipping-radio',
      formsRadio: () => '.form-shipping .shipping-radio',
      selectShippingInputs: () => '.select-shipping',
      radioByName: (name) => `[type="radio"][data-name="${name}"]`,
      radioByNameChecked: (name) => `[type="radio"][data-name="${name}"]:checked`,
      checkedShipOption: () => '.ship_option .ship-option:checked',
      formShipping: () => '.line-item-extra-details .form-shipping',
      shipOption: () => '.ship-option',
      shipOptionByValue: (value) => `.ship-option[value="${value}"]`,
    },

    modals: {
      zipError: () => '#product-store-default-zip-popup .error_location',
    },

    warranty: {
      parentProduct: () => '.warranty_parent_product',
      selectedRadioBySku: (sku) => `input.product-radio[data-parent-sku="${sku}"]:checked`,
      selectedRadioByLineId: (lineId) => `input.product-radio[data-parent-line-id="${lineId}"]:checked`,
    },

    misc: {
      liveZipCode: () => '.live-zip-code',
      cartContent: () => '.cart-content',
      storeLocationLabels: () => '.shipping-optin-cover span.store',
      cartProductItems: () => '.cart-content .shopping-cart-content .product-item',
      oldAddresses: () => '.old_addresses',
      deliveryOptionsError: () => '.delivery-options-error-message',
    },
  },
};

window.CartSelectors = CartSelectors;
